import React from 'react';

export default class PDVErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[PDV ErrorBoundary]', error, info);
        this.setState({ info });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '40px 24px',
                    fontFamily: 'system-ui, sans-serif',
                    minHeight: '100vh',
                    background: '#f8f9fc',
                    color: '#0f172a',
                }}>
                    <div style={{
                        maxWidth: 800,
                        margin: '0 auto',
                        background: '#fff',
                        padding: 24,
                        borderRadius: 12,
                        border: '2px solid #ef4444',
                        boxShadow: '0 4px 6px rgba(0,0,0,.08)',
                    }}>
                        <h1 style={{ color: '#ef4444', marginTop: 0 }}>🚨 PDV falhou ao carregar</h1>
                        <p style={{ color: '#475569' }}>O componente do PDV explodiu em runtime. Detalhes abaixo:</p>
                        <h3 style={{ marginTop: 24 }}>Erro:</h3>
                        <pre style={{
                            background: '#1e293b',
                            color: '#38bdf8',
                            padding: 16,
                            borderRadius: 8,
                            overflow: 'auto',
                            fontSize: 13,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                        }}>
                            {String(this.state.error?.message || this.state.error)}
                        </pre>
                        {this.state.error?.stack && (
                            <>
                                <h3>Stack:</h3>
                                <pre style={{
                                    background: '#0f172a',
                                    color: '#94a3b8',
                                    padding: 16,
                                    borderRadius: 8,
                                    overflow: 'auto',
                                    fontSize: 11,
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                }}>
                                    {this.state.error.stack}
                                </pre>
                            </>
                        )}
                        {this.state.info?.componentStack && (
                            <>
                                <h3>Componente:</h3>
                                <pre style={{
                                    background: '#0f172a',
                                    color: '#94a3b8',
                                    padding: 16,
                                    borderRadius: 8,
                                    overflow: 'auto',
                                    fontSize: 11,
                                    whiteSpace: 'pre-wrap',
                                }}>
                                    {this.state.info.componentStack}
                                </pre>
                            </>
                        )}
                        <p style={{ color: '#475569', marginTop: 24, fontSize: 13 }}>
                            Tire screenshot dessa tela e mande para o desenvolvedor.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                marginTop: 16,
                                padding: '10px 20px',
                                background: '#22c55e',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 8,
                                cursor: 'pointer',
                                fontWeight: 700,
                            }}
                        >
                            Tentar novamente
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
